export var gaCalls = [];
export default {
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/react-ga/dist/esm/utils/testModeAPI.js
// module id = 599
// module chunks = 7